/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AptosBlockDetailInfo } from '../models/AptosBlockDetailInfo';
import type { AptosBlockListInfo } from '../models/AptosBlockListInfo';
import type { AptosBlockSummaryInfo } from '../models/AptosBlockSummaryInfo';
import type { AptosTrxListInfo } from '../models/AptosTrxListInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AptosBlockControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns AptosBlockDetailInfo OK
     * @throws ApiError
     */
    public getAptosBlockDetail({
        blockHeight,
    }: {
        blockHeight: string,
    }): CancelablePromise<AptosBlockDetailInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/block',
            query: {
                'blockHeight': blockHeight,
            },
        });
    }

    /**
     * @returns AptosTrxListInfo OK
     * @throws ApiError
     */
    public getAptosTransactionListByBlockHeight({
        blockHeight,
        page = 1,
        size = 25,
    }: {
        blockHeight: string,
        page?: number,
        size?: number,
    }): CancelablePromise<AptosTrxListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/block/transaction/list',
            query: {
                'blockHeight': blockHeight,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns AptosBlockSummaryInfo OK
     * @throws ApiError
     */
    public getAptosBlockSummaryList({
        size = 10,
    }: {
        size?: number,
    }): CancelablePromise<Array<AptosBlockSummaryInfo>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/block/summary',
            query: {
                'size': size,
            },
        });
    }

    /**
     * @returns AptosBlockListInfo OK
     * @throws ApiError
     */
    public getAptosBlockList({
        page = 1,
        size = 25,
    }: {
        page?: number,
        size?: number,
    }): CancelablePromise<AptosBlockListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/block/list',
            query: {
                'page': page,
                'size': size,
            },
        });
    }

}
